import { LooseObject } from "helpers/type";

export interface Thumbnail {
  id: number;
  article_id: number;
  URL: string;
  thumbnail: boolean;
  created_at: string;
  updated_at: string;
  signed_url?: string;
}

export interface Pivot {
  article_id: number;
  article_category_item_id: number;
}

export interface Category {
  id: number;
  name: string;
  active: boolean;
  created_at: string;
  updated_at: string;
  slug: string;
  pivot: Pivot;
}

export interface Pivot2 {
  article_id: number;
  article_tag_item_id: number;
}

export interface Tag {
  id: number;
  name: string;
  slug: string;
  created_at: string;
  updated_at: string;
  pivot: Pivot2;
}

export interface Image {
  id: number;
  article_id: number;
  URL: string;
  thumbnail: number;
  created_at: string;
  updated_at: string;
  signed_url?: string;
}

export interface Pivot3 {
  article_id: number;
  variant_id: number;
}

export interface ProductVariantImage {
  id: number;
  product_variant_id: number;
  URL: string;
  position: number;
  created_at: string;
  updated_at: string;
  signed_url?: string;
}

export interface Category {
  id: number;
  name: string;
}

export interface Brand {
  id: number;
  name: string;
  flat: string[];
  slug: string;
  ancestors: any[];
}

export interface Product {
  id: number;
  brand_id: number;
  category_id: number;
  name: string;
  created_at: string;
  updated_at: string;
  category: Category;
  brand: Brand;
}

export interface Variant {
  id: number;
  product_id: number;
  display_name: string;
  nickname: string;
  slug: string;
  type: string;
  dimension?: any;
  colour: string;
  weight: number;
  SKU: string;
  sex: string;
  active: boolean;
  editors_choice: boolean;
  editors_position: number;
  hide_box_info: boolean;
  vintage: boolean;
  receive_sell: boolean;
  accept_po: number;
  voucher_applicable: boolean;
  biddable: boolean;
  details: string;
  price_source: string;
  currency: string;
  retail_price: string;
  price?: string;
  release_date: string;
  expiry_date?: any;
  created_at: string;
  updated_at: string;
  auto_sync: boolean;
  pivot: Pivot3;
  product_variant_images: ProductVariantImage[];
  product: Product;
  out_of_stock: number;
  total_available_sizes: number;
}

export interface IArticleMeta {
  content: string;
  id: number;
  name: string;
  pivot: LooseObject;
}

export interface IArticleData {
  id: number;
  title: string;
  slug: string;
  body: string;
  active: number;
  created_at: string;
  updated_at: string;
  thumbnail: Thumbnail;
  categories: Category[];
  tags: Tag[];
  images: Image[];
  variants: Variant[];
  meta?: IArticleMeta[];
}

export interface IArticleListData {
  id: number;
  title: string;
  slug: string;
  body: string;
  active: number;
  created_at: string;
  updated_at: string;
  thumbnail: Thumbnail;
}

export enum EArticleCategory {
  Fashion = 'fashion',
  Popular = 'popular',
  Sneakers = 'sneakers',
  Luxury = 'luxury',
  Latest = 'latest', //It's not real category (virtual data in FE)
  All = '',
}
